import "./login.css"
import CustomBtn from '../../components/CustomBtn';
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { setUserSession } from "../../service/AuthService";
import { Lock, Person } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const createUser = process.env.REACT_APP_LOGIN_USER_API_URL;

export default function Login(props) {
    const [userName, setName] = useState('');
    const [password, setPass] = useState('');
    const [message, setMessage] = useState(null);
    const history = useHistory();
    useEffect(() => {
        document.title = "Smishtank: Login"
    }, []);
    const submitHandler = (event) => {
        event.preventDefault();
        if (userName.trim() === '' || password.trim() === '')
        {
            setMessage("All input fields are required.");
            return;
        }

        const requestConfig = {
            headers: {
                'x-api-key': process.env.REACT_APP_API_GATEWAY_KEY,
            }
        }
        const requestBody = {
            username: userName,
            password: password
        }
        axios.post(createUser,requestBody,requestConfig).then(response => {
            setUserSession(response.data.user, response.data.token);
            props.handleLogin();
            history.push("/");
        }).catch(error => {
            if (error.response.status === 401 || error.response.status === 403)
            {
                setMessage(error.response.data.message);
            } else {
                setMessage('The backend server is currently down, please try again later')
            }
        })
    }

    return (
        <div className="login">
            <div className="LoginFormContainer">
                <span className="messageDetails">Login</span>
                <form onSubmit={submitHandler} className="loginForm" id="login">
                    <div className="messageInfo">
                        <label>
                            <Person className="messageIcon" />
                            <span className="label-align">Username</span>
                        </label>
                        <input 
                            value={userName}
                            type="text" 
                            placeholder="username" 
                            className="userName"
                            onChange={event => setName(event.target.value)}
                        />
                    </div>
                    <div className="messageInfo">
                        <label>
                            <Lock className="messageIcon" />
                            <span className="label-align">Password</span>
                        </label>
                        <input 
                            value={password}
                            type="password" 
                            placeholder="pass" 
                            className="userPass"
                            onChange={event => setPass(event.target.value)}
                        />
                    </div>
                    <div className="SmishTitleContainer">
                        <Button component={Link} to="/register" variant="contained" color="primary" className="addSmishTitle">
                            Register
                        </Button>
        
                        <CustomBtn txt="Submit" form="submitSmish" /> 
                    </div> 
                </form>
                {message && <p className="message">{message}</p>}
            </div>
        </div>
    )
}